module.exports = __webpack_public_path__ + "static/media/arrow.f8ee1ae2.svg";